<template>
  <button
    ref="trigger"
    v-click-away="close"
    class="button is-tooltip"
    :class="{ 'is-active': visible }"
    @click="onClick"
  >
    <span>?</span>
    <div v-if="visible" class="help-box" :style="style">
      <slot />
    </div>
  </button>
</template>

<script lang="ts" setup>
/* Previously:
data() {
 return {
   visible: false as any,
   top: 0,
   left: 0,
   width: 375 - 32,
 }
}
*/
const visible = ref(false)
const top = ref(0)
const left = ref(0)
const width = ref(375 - 32)

const trigger = ref<HTMLButtonElement>()

/* Previously:
computed: {
 style(): any {
   return {
     top: this.top + 'px',
     left: this.left + 'px',
     width: this.width + 'px',
   }
 }
}
*/
const style = computed(() => ({
  top: top.value + 'px',
  left: left.value + 'px',
  width: width.value + 'px',
}))

/* Previously:
methods: {
 close() {
   this.visible = false
 },
 onClick() {
   if (this.visible) {
     this.visible = false
     return
   }
   const el = this.$refs.trigger as HTMLButtonElement
   const rect = el.getBoundingClientRect()
   this.left = Math.min(rect.x - 15, 90) * -1
   this.top = rect.height + 8
   this.visible = true
 }
}
*/
function close() {
  visible.value = false
}

function onClick() {
  if (visible.value) {
    visible.value = false
    return
  }

  if (!trigger.value) return

  const rect = trigger.value.getBoundingClientRect()
  left.value = Math.min(rect.x - 15, 90) * -1
  top.value = rect.height + 8
  visible.value = true
}
</script>

<style>
@reference '~/assets/css/tailwind.css';
.button.is-tooltip {
  @apply relative inline-flex h-[1.25em] w-[1.25em] items-center justify-center rounded-full p-0 text-center align-baseline;
  min-width: initial;
  font-size: inherit;
  &:not(:first-child) {
    @apply ml-[0.25em];
  }
  &.is-active {
    cursor: normal;
    &:after {
      content: '';
      @apply absolute mt-[4px];
      border-color: transparent transparent rgb(var(--color-primary));
      border-style: solid;
      border-width: 0 0.5em 0.5em;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  > span {
    @apply text-[0.8em] font-bold;
  }
}
.help-box {
  @apply absolute z-100 w-[24rem] bg-primary p-[1rem] text-left text-[1rem] whitespace-normal text-scheme-main;
  box-shadow: #2f3443;
}
</style>
